import { Box, Container, Link, Typography } from "@mui/material";
import { config } from '../utils/config';

export default function Footer() {
    return (
        <>
                <Box 
                        component="footer"
                        id="footer"
                        sx={{
                            mt: "auto", // Equivalente a "mt-auto" de Bootstrap
                            py: 2, // Padding vertical
                        }}
                        >
                
                    <Box sx={{ textAlign: "start", p: 2 }}>
                        {/* Se oculta en pantallas pequeñas y aparece en md en adelante */}
                        <Box sx={{ display: { xs: "none", md: "block" }, maxWidth: "66.67%", mt: 2 }}>
                            <Typography variant="body2" color="text.primary">
                            <strong>
                                Copyright © 2026{" "}
                                <Link href="https://sani.cl/" target="_blank" rel="noreferrer">
                                Powered by SANI
                                </Link>
                                . Todos los derechos reservados. v{config.APP_VERSION}{" "}{config.APP_FECHA_VERSION}
                            </strong>
                            </Typography>
                        </Box>
                    </Box>
                
                </Box>
        </>
    )
}
